import React from 'react';
import { boundPosition } from '../utils';
const noop = () => undefined;
export const useDragOnMouseMove = (payload) => {
    const position = React.useRef();
    const [isDragged, setIsDragged] = React.useState(false);
    const onStartDragging = React.useCallback((event) => {
        if (event.buttons !== 1) {
            return;
        }
        if (!payload.elementRef.current) {
            return;
        }
        setIsDragged(true);
        position.current = {
            x: payload.elementRef.current.offsetLeft - event.clientX,
            y: payload.elementRef.current.offsetTop - event.clientY,
        };
    }, [payload.elementRef]);
    const onStopDragging = React.useCallback((event) => {
        if (!position.current || !payload.elementRef.current) {
            return;
        }
        const boundedPosition = boundPosition({
            x: position.current.x + event.clientX,
            y: position.current.y + event.clientY,
        }, payload.elementRef.current);
        if (payload.onStopDragging) {
            payload.onStopDragging(boundedPosition);
        }
        position.current = undefined;
        setIsDragged(false);
    }, [payload]);
    const onMouseMove = React.useCallback((event) => {
        if (event.buttons !== 1) {
            onStopDragging(event);
            return;
        }
        if (!position.current || !payload.elementRef.current) {
            return;
        }
        const boundedPosition = boundPosition({
            x: position.current.x + event.clientX,
            y: position.current.y + event.clientY,
        }, payload.elementRef.current);
        Object.assign(payload.elementRef.current.style, {
            left: `${boundedPosition.x}px`,
            top: `${boundedPosition.y}px`,
        });
    }, [onStopDragging, payload.elementRef]);
    return {
        onStartDragging: payload.isDisabled ? noop : onStartDragging,
        onStopDragging: payload.isDisabled ? noop : onStopDragging,
        onDrag: payload.isDisabled ? noop : onMouseMove,
        isDragged,
    };
};
